import React from 'react';
import NavBar from 'shared/NavBar/NavBar';
import { Container } from 'lmc-ui-library';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { ThemeProvider } from 'lmc-ui-library-rebrand';

import style from './Registration.module.scss';
import Footer from 'shared/Footer/Footer';

type Props = {};

const RegistrationTemplate: React.FC<Props> = ({ children }) => {
  useBodyClass(...style['registration'].split(' '));

  return (
    <>
      <ThemeProvider
        useFonts={(fonts) => ({
          ...fonts,
          primary: 'var(--primary-font-rebrand)',
          secondary: 'var(--secondary-font-rebrand)',
        })}>
        <header>
          <NavBar fixed={false} newUi />
        </header>
        <div>
          <Container p={0} mt={80} mb={60} className={style.container}>
            {children}
          </Container>
        </div>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default RegistrationTemplate;
